export default "__VITE_ASSET__DvF5gfeR__"